import { IReduxState } from '../../types/redux';
import * as R from 'ramda';
import { EMortgageBuildingType } from '../../types/mortgage/mortgageType';

export const buildMortgageHref = (state: IReduxState) => {
  const params = getMortgageHrefParams(state);
  const path = '/ipoteka/calculator/';
  if (params.size === 0) {
    return path;
  }
  const paramsString =
    Array.from(params.entries())
      .map((item) => `${encodeURIComponent(item[0])}=${encodeURIComponent(item[1])}`)
      .join('&');

  return `${path}?${paramsString}`;
};

function getRegionParameter(state: IReduxState): number | undefined {
  const searchRegion = R.path<number>(['filters', 'jsonQuery', 'region', 'value', 0], state);
  const mortgageRegion = R.path<number>(['mortgage', 'filterRegionId'], state);

  return mortgageRegion || searchRegion;
}

function getRealtyTypeParameter(state: IReduxState): string | undefined {
  const buildingType = R.path<EMortgageBuildingType>(['mortgage', 'filterBuildingType'], state);
  switch (buildingType) {
    case EMortgageBuildingType.HousePart:
      return 'room';
    case EMortgageBuildingType.NewBuilding:
      return 'flatNew';
    case EMortgageBuildingType.OldBuilding:
      return 'flatSecondary';
    case EMortgageBuildingType.Suburban:
      return 'houseOrTownhouse';
    default:
      return undefined;
  }
}

function getMortgageHrefParams(state: IReduxState): Map<string, string> {
  const mortgageHrefParams: Map<string, string> = new Map();
  mortgageHrefParams.set('scrollToCalc', 'true');
  const region = getRegionParameter(state);
  if (region) {
    mortgageHrefParams.set('region', region.toString());
  }
  const realtyType = getRealtyTypeParameter(state);
  if (realtyType) {
    mortgageHrefParams.set('realtyType', realtyType);
  }
  const term = R.path<number>(['mortgage', 'filterTerms'], state);
  if (term != null) {
    mortgageHrefParams.set('term', term.toString());
  }
  const amount = R.path<number>(['mortgage', 'filterRealtyPrice'], state);
  if (amount != null) {
    mortgageHrefParams.set('amount', amount.toString());
  }
  const deposit = R.path<number>(['mortgage', 'filterDownPayment'], state);
  if (deposit != null) {
    mortgageHrefParams.set('deposit', deposit.toString());
  }

  return mortgageHrefParams;
}
